export { default } from './EzLoadMore.vue';
